import { ApiClient } from '../ApiClient';
class BasketApiClient {
    constructor() {
        this.apiClient = new ApiClient('/api/basket');
    }
    get() {
        return this.apiClient.get('');
    }
    addItem(request) {
        return this.apiClient.post('/add-item', request);
    }
    addItems(data) {
        return this.apiClient.post('/add-items', data);
    }
    updateItem(orderLineId, newQuantity) {
        return this.apiClient.post('/update-item', { orderLineId, newQuantity });
    }
    updateShipment(data) {
        return this.apiClient.post('/update-shipment', data);
    }
    updateShipmentAddress(address) {
        return this.apiClient.post('/update-shipment-address', { address });
    }
    empty() {
        return this.apiClient.post('/empty-basket', {});
    }
    isCorrectStatus() {
        return this.apiClient.get('/is-correct-status');
    }
    applyDiscountCode(discountCode) {
        return this.apiClient.post('/apply-discount-code', { discountCode });
    }
    removeDiscountCode(discountCode) {
        return this.apiClient.post('/remove-discount-code', { discountCode });
    }
}
const basketApiClient = new BasketApiClient();
export default basketApiClient;
